import useValidate from 'src/core/CoreFilePicker/composables/useValidate'

// Мок createImage
jest.mock('src/core/CoreFilePicker/functions/createImage', () => jest.fn((src: string) => Promise.resolve({
  src,
  width: 8,
  height: 8,
})))

global.URL.createObjectURL = jest.fn()
global.URL.revokeObjectURL = jest.fn()

const createFile = (filename: string, type: string = 'image/jpeg'): File => new File(['content'], filename, { type })
const { validateFile, validateImage } = useValidate()

describe('useValidate', () => {
  beforeEach(() => {
    jest.clearAllMocks()
  })

  describe('validateFile', () => {
    const validRule = {
      validate: (f: File) => f.size < 1000000,
      error: 'Error',
    }
    const invalidRule = {
      validate: (f: File) => f.size < 4,
      error: 'Error',
    }

    test('Тогда без правил валидация проходит', async () => {
      const file = createFile('test.pdf')
      const result = await validateFile(file)

      expect(result).toBe(true)
    })

    test('Тогда с валидными правилами валидация проходит', async () => {
      const file = createFile('test.pdf', 'application/pdf')
      const result = await validateFile(file, [validRule])

      expect(result).toBe(true)
    })

    test('Тогда с невалидным правилом возвращает ошибку этого правила', async () => {
      const file = createFile('test.pdf')
      const result = await validateFile(file, [validRule, invalidRule])

      expect(result).toBe(invalidRule.error)
    })
  })

  describe('validateImage', () => {
    const validRule = {
      validate: (img: HTMLImageElement) => img.width > 6,
      error: 'Error',
    }
    const invalidRule = {
      validate: (img: HTMLImageElement) => img.width > 10,
      error: 'Error',
    }

    test('Тогда без правил валидация проходит', async () => {
      const file = createFile('test.jpg')
      const result = await validateImage(file, undefined)

      expect(result).toBe(true)
    })

    test('Тогда для не-изображения валидация проходит', async () => {
      const file = createFile('test.pdf', 'application/pdf')
      const result = await validateImage(file, [invalidRule])

      expect(result).toBe(true)
    })

    test('Тогда с валидным правилом для изображения валидация проходит', async () => {
      const file = createFile('test.png', 'image/png')
      const result = await validateImage(file, [validRule])

      expect(result).toBe(true)
    })

    test('Тогда с невалидным правилом для изображения возвращает error', async () => {
      const file = createFile('test.png', 'image/png')
      const result = await validateImage(file, [validRule, invalidRule])

      expect(result).toBe(invalidRule.error)
    })
  })
})
